/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnaccounts2Inputs */

const en_opportunitiescolumnaccounts2 = /** @type {(inputs: Opportunitiescolumnaccounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts`)
};

const de_opportunitiescolumnaccounts2 = /** @type {(inputs: Opportunitiescolumnaccounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten`)
};

/**
* | output |
* | --- |
* | "Accounts" |
*
* @param {Opportunitiescolumnaccounts2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnaccounts2 = /** @type {((inputs?: Opportunitiescolumnaccounts2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnaccounts2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnaccounts2(inputs)
	return de_opportunitiescolumnaccounts2(inputs)
});
export { opportunitiescolumnaccounts2 as "opportunitiesColumnAccounts" }